import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Toggle } from "shared/components/Toggle";
import { Message, Select } from "@components";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class BlingSellerDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      step: null,
      account: null,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  componentWillUnmount() {}

  async loadConfigs() {
    try {
      const environmentId = EnvironmentStorage.getEnvironment().id;

      const sellersResponse = await IntegrationsAPI.getBlingSellers(
        environmentId
      );
      const sellers = sellersResponse.getData([]);

      const configurationsResponse = await IntegrationsAPI.getBlingConfigurations(environmentId);
      const configurations = configurationsResponse.getData([]);

      this.setState({
        loadingPage: false,
        sellers,
        configurations,
      });
    } catch (err) {
      console.log(err);
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { configurations } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const updateResponse = await IntegrationsAPI.upsertBlingConfigurations(environmentId, configurations);

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  buildSelectOptions(options, selectedValue) {
    const builtOptions = options.map((option) => ({
      label: option.name,
      value: option.id,
      selected: option.id === selectedValue,
    }));

    return [
      {
        label: "Selecione",
        value: null,
        selected: !selectedValue,
      },
      ...builtOptions,
    ];
  }

  render() {
    const { loading, loadingPage } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        title={"Bling - Vendedor"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading}
          >
            Salvar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Message
              type="info"
              title="Vendedor"
              text="Configuração opcional que permite definir o vendedor do pedido"
              className="mb-20"
            />

            <Select
              design="two"
              label={`Vendedor`}
              onChange={(e) =>
                this.setState({
                  configurations: {
                    ...this.state.configurations,
                    sellerId: e.target.value,
                  },
                })
              }
              className="mb-20"
              value={this.state.configurations?.sellerId}
              options={this.buildSelectOptions(
                this.state.sellers,
                this.state.configurations?.sellerId
              )}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
